module.exports = __webpack_public_path__ + "f2e4ece690a883fb01d13509728cd6db.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=1200!./src/components/cover/teaser.jpg?size=1200w
// module id = 34
// module chunks = 1